import styled from 'styled-components';
import Box from '../layout/Box';
var OrderedList = styled(Box).attrs({
  as: 'ol'
}).withConfig({
  displayName: "OrderedList",
  componentId: "sc-9jomvr-0"
})(["counter-reset:number;", ""], function (_ref) {
  var theme = _ref.theme,
      $variant = _ref.$variant;
  return $variant && theme.expandVariants($variant, theme.typography.lists.ordered);
});
OrderedList.displayName = 'OrderedList';
export default OrderedList;